<script lang="ts">
  import NoProductAvailable from "@shared/svelte/Components/NoProductAvailable.svelte";
  import ProductLineGrid from "@retailer/svelte/ProductLines/Index/ProductLineGrid.svelte";
  import ProductLineList from "@retailer/svelte/ProductLines/Index/ProductLineList.svelte";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import { CustomContentProductListEntity } from "@shared/services/event_tracking/entities";
  import { CustomContentProductListLayoutTypes } from "@shared/types/CustomContent";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { compact } from "lodash";
  import { fetchSupplementalData } from "@retailer/services/product_results_services";

  import type { ProductLine } from "@shared/types/ProductLine";

  export let layout: CustomContentProductListLayoutTypes = CustomContentProductListLayoutTypes.Grid;
  export let mobileMode: boolean = false;
  export let productLineIds: number[];
  export let stateParams: any = {};
  export let title: string | null = null;
  export let trackingData: any = {};
  export let productLinesApiUrl: string = "/api/retailer/product_lines";
  export let Cart = null;

  // Unused props passed from discovery panel
  export let type: string = null;
  type;

  let productLinesLoaded: boolean = false;
  let productLines: ProductLine[] = [];
  const options = {
    method: "GET",
    url: productLinesApiUrl,
    data: {
      ids: productLineIds,
    },
  };

  if (productLineIds.length) {
    HttpPromise(options).then(res => {
      // Order the product lines in the same order they are configured to be in
      productLines = compact(
        productLineIds.map(id => res.find(r => r?.id && parseInt(r.id) === id)),
      );
      productLinesLoaded = true;

      if (layout == CustomContentProductListLayoutTypes.List) {
        fetchSupplementalData(productLines);
      }
    });
  }

  const trackingEntity = new CustomContentProductListEntity(trackingData);
</script>

<TrackingContext entities={trackingEntity}>
  <div class="fizz-styles" data-testid="self-fetching-product-list">
    {#if title}
      <div
        class="fizz-container fizz-inset-square-16 fizz-flex-row-responsive"
        data-testid="product-list-title"
      >
        <h2 class="fizz-heading-2">{title}</h2>
      </div>
    {/if}

    <!-- This component is utilized for Admin Preview as well, so when product lines have not yet been added (i.e. productLineIds
    is an empty array), we do not want to show this section at all as we will instead show the placeholder in the preview component. -->
    {#if productLineIds.length && productLinesLoaded}
      <div class="fizz-container fizz-inset-horizontal-16" data-testid="product-cards-container">
        {#if productLines.length}
          {#if layout == CustomContentProductListLayoutTypes.Grid}
            <ProductLineGrid
              bind:productLines
              {stateParams}
              bind:mobileMode
              useStoreForCardData={false}
              trackProductIndexLayout={true}
            />
          {:else}
            <div class="fizz-stack-24">
              <ProductLineList bind:productLines {stateParams} bind:mobileMode {Cart} />
            </div>
          {/if}
        {:else}
          <NoProductAvailable />
        {/if}
      </div>
    {/if}
  </div>
</TrackingContext>
